import {FetchSourcePostType, SourcePostFormFieldsEnum} from '../../../../../../../../service/posts/posts-types';

export const POST_SOURCE_INITIAL_VALUES: Omit<FetchSourcePostType, SourcePostFormFieldsEnum.Catalog> = {
    [SourcePostFormFieldsEnum.Text]: '',
    [SourcePostFormFieldsEnum.Images]: [],
};
